module.exports = __webpack_public_path__ + "img/005.5b90b62f.png";